/**
 * Created by Desarrollo KJ on 20/3/2017.
 */
import {Component, OnInit} from '@angular/core';
import {ApiService} from './../../../services/api.service';

@Component({
  selector: 'my-shopping-list',
  template: require('./myShoppingList.html')
})
export class MyShoppingListComponent implements OnInit {

  public listShoppings:any = [];
  public pais:any = JSON.parse(localStorage.getItem('pais'));

  constructor(private _api: ApiService) {
    this._api.getFacturas().subscribe(
      result=>{
        this.listShoppings = result;
      }
    )
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/adminUser/myShoppingList/myShoppingList.component.ts